export enum BatchStatus {
  Queued = 1,
  InProgress = 2,
  Complete = 3,
  FailedToComplete = 4,
  Canceled = 5,
  Canceling = 6,
  WaitingUserAction = 7,
  WaitingExternalTrigger = 8,
  ValidationFailed = 14,
}

export enum BatchTabType {
  Claims = 'Claims',
  Processing = 'Processing',
  Processed = 'Processed',
  Archived = 'Archived',
  EOB = 'EOB',
  EOBReview = 'EOBReview',
  UnSupportedFax = 'UnSupportedFax',
}

export enum BatchProcessingStatus {
  Initiallizing = 0,
  Queued = 1,
  Validating = 2,
  Pending_Approval = 7,
  Uploading_Claims = 8,
  AutoCheck_In_Queue = 9,
  Ready_for_Processing = 10, //changed renamed from Ready_for_AutoCheck
  Cancelled = 5,
  Complete = 3,
  Cancelling = 6,
  FailedToComplete = 4,
  AutoCheck_In_Progress = 11,
  Validation_Completed = 12,
  Awaiting_EOB = 13, // Added for place holder, we may not use it
  ValidationFailed = 14,
}

export enum BatchProcessingToStatus {
  Initiallizing = 'Initiallizing',
  Queued = 'Queued',
  Validating = 'Validating',
  Pending_Approval = 'Pending Approval',
  Uploading_Claims = 'Uploading Claims',
  AutoCheck_Started = 'AutoCheck Started',
  Ready_for_Processing = 'Ready for Processing', //changed renamed from Ready_for_AutoCheck
  Cancelled = 'Cancelled',
  Complete = 'Complete',
  Cancelling = 'Cancelling',
  FailedToComplete = 'Failed to Complete',
  Autocheck_Submitted = 'AutoCheck Submitted',
  Validation_Completed = 'Validation Completed', // Added for place holder, we may not use it
}

export enum BatchType {
  Claim_Autocheck = 1,
  Claim_Import = 2,
  Claim_Validate = 3,
  Claim_Autocheck_EOB = 4,
  Claim_Export = 5,
  Claim_ASC = 7,
}

export enum BatchErrors {
  other = 'Other',
  unSupportedPhoneNumbers = 'Unsupported or missing phone number(s)',
  missingRequiredFields = 'Data validation failure(s); Missing required field(s)',
  identicalUniqueIds = 'Identical unique ID(s)',
  invalidDataFormat = 'Data validation failure(s); Invalid data format(s)',
  invalidOrImpreciseValues = 'Imprecise value(s)',
  invalidFormatting = 'Invalid format(s)',
  valueExceedsLimit = 'Data validation failure(s); Value(s) exceeds limits',
  valueOutOfBounds = 'Value(s) out of bounds',
}

export enum ClaimValidationStatus {
  NOT_CHECKED = 0,
  VALIDATION_FAILED = 1,
  VALID_FOR_IMPORT = 2,
  VALID_FOR_AUTOCHECK = 3,
  VALID_FOR_AUTOCHECK_EOB = 4,
}

export enum ValidationDownloadEnum {
  full = 'full',
  errorOnly = 'error-only',
  successOnly = 'success-only',
}
